import React from 'react';
import { getTranslateByScope } from '../../../../../i18n';
import { positions, salutations } from '../../../CustomerListConstants';
const translate = getTranslateByScope('customerList');

const Dropdown = (data, props) => {
  const keys = Object.keys(data).filter((e) => e !== undefined);
  const sortedKeys = keys.toSorted((a,b) => a.toLowerCase().localeCompare(b.toLowerCase()));

  return (
    <select
      name={props.name}
      className={props.className || ''}
      value={props.value || ''}
      onChange={props.onChange}
      multiple={!!props.multiple}
    >
      {sortedKeys.map((k) => {
        let v = data[k];
        return (
          <option key={k} value={v}>
            {k}
          </option>
        );
      })}
    </select>
  );
};

export const SalutationDropdown = (props) => {
  let translatedSalutations = {};
  Object.keys(salutations).forEach((k) => {
    const tk = translate(`salutation.${k}`);
    const v = salutations[k];
    translatedSalutations[tk] = v;
  });

  return Dropdown(translatedSalutations, props);
};

export const PositionDropdown = (props) => {
  return Dropdown(positions, props);
};
